import { useEffect, useState } from 'react';
import UserLayout from 'layouts/UserLayout';
import OrderService from 'services/orderService';
import UserService from 'services/userService';

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [detailOrder, setDetailOrder] = useState({});
  const [currentUser] = useState(UserService.getCurrentUser());

  function handleOrderClick(order_id) {
    return async () => {
      const detail = await OrderService.getDetailOrder(order_id);
      setDetailOrder(detail);
    };
  }

  useEffect(() => {
    const user_id = UserService.getCurrentUserId();
    UserService.getUserOrders(user_id).then((data) => {
      setOrders(data);
      sessionStorage.setItem('orders', JSON.stringify(data));
    });
  }, []);

  return (
    <UserLayout currentUser={currentUser}>
      <div className="grid grid-cols-1 lg:grid-cols-5 2xl:grid-cols-3 gap-4 w-full min-h-[80vh] max-h-[80vh] p-4 pt-0 text-white">
        <div className="bg-[#1B1B1B] lg:col-span-3 2xl:col-span-2 border border-[#2f2f2f] pt-4 rounded-2xl shadow-md h-full max-h-[80vh]">
          <h1 className="text-xl font-bold text-center mb-4">Orders List</h1>
          <div className="border-t border-[#363636] my-2 w-full" />
          <div className="h-[85%] px-4 pb-4 overflow-y-scroll scrollbar-thin">
            {orders.length > 0 ? (
              orders.map((order) => (
                <div key={order.id} className="p-4 hover:bg-[#363636] rounded-xl cursor-pointer" onClick={handleOrderClick(order.id)}>
                  <h3 className="text-center text-lg font-medium">
                    <code>{order.id}</code>
                  </h3>
                </div>
              ))
            ) : (
              <div className="px-8 py-4 text-center">No orders found</div>
            )}
          </div>
        </div>

        <div className="bg-[#1B1B1B] lg:col-span-2 2xl:col-span-1 border border-[#2f2f2f] pt-4 rounded-2xl shadow-md">
          <h1 className="mb-4 text-xl font-bold text-center">Detail Order</h1>
          <div className="border-t border-[#363636] my-2 w-full overflow-y-scroll scrollbar-thin" />
          {Object.keys(detailOrder).length > 0 ? (
            <>
              <div className="px-4 py-2 text-sm overflow-clip">
                <div className="flex justify-between items-center gap-2">
                  <h3 className="text-base">Order ID</h3>
                  <span
                    className="
                    px-2 py-1
                  bg-[#363636] rounded-full
                    text-xs
                    "
                  >
                    {detailOrder.id}
                  </span>
                </div>
              </div>
              <div className="border-t border-[#363636] mt-2 w-full" />
              <div className="flex items-center justify-between px-4 py-4">
                <div className="text-sm w-full">
                  <div className="relative bottom-0 justify-between items-center">
                    <div className="flex justify-between items-center">
                      <h3 className="text-base">Product ID</h3>
                      <span
                        className="
                        px-2 py-1
                      bg-[#363636] rounded-full
                        text-xs"
                      >
                        #{detailOrder.product_id}
                      </span>
                    </div>
                    <div className="flex justify-between items-center">
                      <h3 className="text-base">Product Name</h3>
                      <h3>{detailOrder.product_name}</h3>
                    </div>
                    <div className="flex justify-between items-center">
                      <h3 className="text-base">Product Price</h3>
                      <h3>{detailOrder.price} 🪙</h3>
                    </div>
                  </div>
                </div>
                <img
                  src={'/api/v2/image/resize?image=' + detailOrder.product_image + '&size=small'}
                  alt="Product"
                  className="ml-4 rounded-lg border border-[#363636] object-cover"
                />
              </div>
              <div className="border-t border-[#363636] mt-2 w-full" />
              <div className="px-4 py-2 text-sm overflow-clip mt-2">
                <div className="flex justify-between items-center gap-2">
                  <h3 className="text-base">Created At</h3>
                  <span
                    className="
                    px-2 py-1
                  bg-[#363636] rounded-full
                    text-xs
                    "
                  >
                    {detailOrder.created_at.replace('T', ' ').replace('Z', '').split('.')[0]}
                  </span>
                </div>
              </div>
              <div className="border-t border-[#363636] mt-2 w-full" />
              <div className="p-4 text-sm">
                <h3 className="text-base text-nowrap">Your Note</h3>
                <p className="mt-4 text-indigo-300">{detailOrder.note ? detailOrder.note : 'You have not added any note'}</p>
              </div>
            </>
          ) : (
            <div className="px-8 py-4 text-center">No order selected</div>
          )}
        </div>
      </div>
    </UserLayout>
  );
}
